<!-- <pre>{{globalFiltersService?.allFilters | json}}</pre> -->
<div class="filter-wrapper">
    <div class="d-block d-sm-block d-md-block d-lg-none d-xl-none close-btn">
        <img (click)="onClose()" [src]="IMAGE_URLS.closeIconDark" class="close-icon" />
    </div>

    <!--Current Filters-->
    @if (appliedFilters(); as appliedFilters) {
    @if (appliedFilters.length > 0) {
    <div class="applied-filter-section">
        <section class="d-flex justify-content-between align-items-center">
            <h4>
                {{ appliedFilters.length }}
                {{ appliedFilters.length > 1 ? 'Filters' : 'Filter' }} Applied
            </h4>
            <span (click)="resetAllFilters()">Clear all</span>
        </section>
    </div>
    }
    }
    @for (filter of filters(); track filter.label + '_' + $index) {
    <filter-collapse [title]="filter?.label || ''" [collapsed]="filter?.type !== 'category'">
        <div class="filter-content">
            @switch (filter?.label) {
            @case (AttributeType.Size) {
            <size-filter [checkboxFilterInput]="filter" (selectedFilter)="updateFilter($event)" [label]="filter?.label || ''"></size-filter>
            }
            @case (AttributeType.Color) {
            <color-filter [checkboxFilterInput]="filter" (selectedFilter)="updateFilter($event)" [label]="filter?.label || ''">
            </color-filter>
            }
            @default {
            <common-filter [checkboxFilterInput]="filter" (selectedFilter)="updateFilter($event)"></common-filter>
            }
            }
        </div>
    </filter-collapse>
    }
</div>